/* Jquery match height */
$('.footer-list').matchHeight();
$('.TeamList_item').matchHeight();

